module.exports = __webpack_public_path__ + "media/images/parking accessible aux pmr-94f02087cd18414ce3bc67edd0a5206e.svg";